import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// If the HTML was prerendered at build time, hydrate it. Otherwise,
// do a normal client render. This dual path keeps dev (`yarn start`)
// snappy while letting the production build serve prerendered HTML
// to crawlers (Google, ChatGPT, Perplexity, Claude, etc.).
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
